import { SimulationInfrastructure } from '@services/simulation';
import { FC } from 'react';
import { ChartInfrastructure } from '../ChartInfrastructure';

export interface IExecuteSummaryInfrastructureProps {
	infrastructure?: SimulationInfrastructure;
}

export const ExecuteSummaryInfrastructure: FC<IExecuteSummaryInfrastructureProps> = ({ infrastructure }) => {
	return <ChartInfrastructure infrastructure={infrastructure} />;
};
